import { FaCheckCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SellerGst } from "../../redux/slices/SellerGstSlice";
import { SellerPan } from "../../redux/slices/SellerPanSlice";
import { SellerAddress } from "../../redux/slices/SellerAddressSlice";
import { useNavigate } from "react-router-dom";
import { SellerBank } from "../../redux/slices/SellerBankSlice";
import { GetSellerData } from "../../redux/slices/GetSellerDataSlice";

const steps = [
  { name: "Verify tax details" },
  { name: "Shipping & Pickup address" },
  { name: "Bank details" },
];

const GstRegistration = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(1);
  const [gstNumber, setGstNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [panName, setPanName] = useState("");
  const [dob, setDob] = useState("");
  const [panImage, setPanImage] = useState(null);
  const [isNonGst, setIsNonGst] = useState(false);
  const [pickupAddress, setPickupAddress] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [accountType, setAccountType] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [buildingNo, setBuildingNo] = useState("");
  const [area, setArea] = useState("");
  const { GetSeller } = useSelector((state) => state.getSeller);

  useEffect(() => {
    // localStorage.removeItem("SellerloginData");
    // localStorage.removeItem("SellerTokenData");
    const SellerId = localStorage.getItem("SellerloginData");
    dispatch(GetSellerData(SellerId));
  }, []);

  useEffect(() => {
    if (!GetSeller?.seller) return;
    if (!GetSeller?.seller?.gstDetails) {
      setCurrentStep(1);
    } else if (!GetSeller?.seller?.addressDetails) {
      setCurrentStep(2);
    } else if (!GetSeller?.seller?.bankDetails) {
      setCurrentStep(3);
    } else {
      navigate("/ThankYouPage");
    }
  }, [GetSeller]);

  const statesWithCities = {
    "Andhra Pradesh": [
      "Visakhapatnam",
      "Vijayawada",
      "Guntur",
      "Tirupati",
      "Nellore",
      "Kurnool",
      "Kadapa",
      "Anantapur",
    ],
    "Arunachal Pradesh": [
      "Itanagar",
      "Naharlagun",
      "Tawang",
      "Ziro",
      "Pasighat",
    ],
    Assam: ["Guwahati", "Dibrugarh", "Silchar", "Jorhat", "Tezpur"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur", "Darbhanga", "Purnia"],
    Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
    Goa: ["Panaji", "Margao", "Vasco da Gama", "Mapusa"],
    Gujarat: [
      "Ahmedabad",
      "Surat",
      "Vadodara",
      "Rajkot",
      "Gandhinagar",
      "Jamnagar",
      "Bhavnagar",
    ],
    Haryana: [
      "Chandigarh",
      "Faridabad",
      "Gurgaon",
      "Panipat",
      "Ambala",
      "Hisar",
    ],
    "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala", "Solan", "Mandi"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
    Karnataka: [
      "Bangalore",
      "Mysore",
      "Mangalore",
      "Belgaum",
      "Hubli",
      "Gulbarga",
    ],
    Kerala: [
      "Kochi",
      "Thiruvananthapuram",
      "Kozhikode",
      "Thrissur",
      "Alappuzha",
      "Palakkad",
    ],
    "Madhya Pradesh": [
      "Bhopal",
      "Indore",
      "Jabalpur",
      "Gwalior",
      "Ujjain",
      "Sagar",
    ],
    Maharashtra: [
      "Mumbai",
      "Pune",
      "Nagpur",
      "Nashik",
      "Aurangabad",
      "Solapur",
      "Kolhapur",
    ],
    Manipur: ["Imphal", "Thoubal", "Bishnupur"],
    Meghalaya: ["Shillong", "Tura", "Jowai"],
    Mizoram: ["Aizawl", "Lunglei"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
    Odisha: [
      "Bhubaneswar",
      "Cuttack",
      "Rourkela",
      "Sambalpur",
      "Puri",
      "Berhampur",
    ],
    Punjab: ["Amritsar", "Ludhiana", "Jalandhar", "Patiala", "Bathinda"],
    Rajasthan: ["Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer", "Bikaner"],
    Sikkim: ["Gangtok", "Namchi"],
    "Tamil Nadu": [
      "Chennai",
      "Coimbatore",
      "Madurai",
      "Tiruchirappalli",
      "Salem",
      "Vellore",
    ],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"],
    Tripura: ["Agartala", "Dharmanagar"],
    "Uttar Pradesh": [
      "Lucknow",
      "Varanasi",
      "Kanpur",
      "Agra",
      "Allahabad",
      "Noida",
      "Meerut",
      "Gorakhpur",
    ],
    Uttarakhand: ["Dehradun", "Haridwar", "Nainital", "Haldwani", "Rishikesh"],
    "West Bengal": [
      "Kolkata",
      "Darjeeling",
      "Asansol",
      "Durgapur",
      "Siliguri",
      "Howrah",
    ],
  };

  const handleNext2 = () => {
    if (!gstNumber.trim()) return toast.error("GST Number is required");
    const data = {
      gstNumber: gstNumber,
    };
    dispatch(SellerGst(data)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
      } else {
        console.log("HEllo");
      }
    });
  };

  const handlePan = () => {
    if (!panNumber.trim()) return toast.error("PAN Number is required");
    if (!panName.trim()) return toast.error("Full Name is required");
    if (!dob.trim()) return toast.error("Date of Birth is required");
    if (!panImage.trim()) return toast.error("PAN Image is required");

    const data = {
      panNumber: panNumber,
      panName: panName,
      dateOfBirth: dob,
      panImage: panImage,
    };
    dispatch(SellerPan(data)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
      } else {
        console.log("HEllo");
      }
    });
  };

  const handleAddress = () => {
    if (!buildingNo.trim()) return toast.error("Building No is required");
    if (!area.trim()) return toast.error("Area Name is required");
    if (!pinCode.trim()) return toast.error("Pin Code is required");
    if (!city.trim()) return toast.error("City is required");
    if (!state.trim()) return toast.error("State  is required");
    if (!pickupAddress.trim())
      return toast.error("Pickup Address  is required");
    const data = {
      buildingNumber: buildingNo,
      area: area,
      pincode: pinCode,
      city: city,
      state: state,
      pickupAddress: pinCode,
    };
    dispatch(SellerAddress(data)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
      } else {
        console.log("HEllo");
      }
    });
  };

  const handleBank = () => {
    if (!accountHolderName.trim())
      return toast.error("Account holder name No is required");
    if (!bankName.trim()) return toast.error("Bank name is required");
    if (!accountNumber.trim()) return toast.error("Account number is required");
    if (!ifscCode.trim()) return toast.error("Ifsc code  is required");
    if (!branchName.trim()) return toast.error("Branch name  is required");
    if (!accountType.trim()) return toast.error("Account Type  is required");

    const data = {
      accountHolderName: accountHolderName,
      bankName: bankName,
      accountNumber: accountNumber,
      pincode: pinCode,
      ifsc: ifscCode,
      branchName: branchName,
      accountType: accountType,
    };
    dispatch(SellerBank(data)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        if (currentStep < steps.length) setCurrentStep(currentStep + 1);
        navigate("/ThankYouPage");
      } else {
        console.log("Hello");
      }
    });
  };

  const handlePanImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPanImage(URL.createObjectURL(file));
    }
  };

  return (
    <section className="max-w-4xl mx-auto p-4 sm:p-6 bg-white sm:border sm:shadow-md rounded-md sm:mt-28 mt-0">
      {/* Step Progress Bar */}
      <div className="relative flex items-center justify-between w-full pb-4 mb-6">
        <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-300 -translate-y-1/2"></div>
        <div
          className="absolute top-1/2 left-0 h-1 bg-blue-500 transition-all duration-300 -translate-y-1/2"
          style={{ width: `${(currentStep / steps.length) * 100}%` }}
        ></div>
        {steps.map((step, index) => (
          <div
            key={index}
            className="relative flex flex-col items-center w-full mb-4 sm:mb-7"
          >
            <div className="">
              {index + 1 < currentStep ? (
                <FaCheckCircle className="text-green-500 text-sm sm:text-lg" />
              ) : (
                <div
                  className={`w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center rounded-full border-2 ${index + 1 === currentStep
                      ? "border-blue-500 text-blue-500 font-bold"
                      : "border-gray-400 text-gray-400"
                    }`}
                >
                  {index + 1}
                </div>
              )}
            </div>
            <span
              className={`absolute top-7 sm:top-9 text-[9px] sm:text-xs text-center mt-1 sm:mt-2 w-15 line-clamp-2 ${index + 1 === currentStep
                  ? "text-blue-600 font-semibold"
                  : "text-gray-500"
                }`}
            >
              {step.name}
            </span>
          </div>
        ))}
      </div>

      {currentStep === 1 && (
        <>
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4">
            Enter GST/PAN details
          </h2>
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
            {isNonGst
              ? "Please enter your PAN details."
              : "GST number is mandatory to sell online."}
          </p>

          {/* GST Number Field */}
          {!isNonGst ? (
            <>
              <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">
                15 Digit GST Number
              </label>
              <input
                type="text"
                placeholder="Enter your GST number"
                maxLength={15}
                minLength={15}
                value={gstNumber}
                onChange={(e) => setGstNumber(e.target.value)}
                className="w-full px-3 py-2 sm:px-4 sm:py-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
              />
              <div className="flex justify-between mt-6">
                <button
                  onClick={() => handleNext2()}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md"
                >
                  Save and continue
                </button>
              </div>
            </>
          ) : (
            <>
              {/* PAN Number Field */}
              <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">
                10 Digit PAN Number
              </label>
              <input
                type="text"
                placeholder="Enter your PAN number"
                maxLength={10}
                minLength={10}
                value={panNumber}
                onChange={(e) => setPanNumber(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
              />

              {/* Full Name Field */}
              <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
                Full Name (As per PAN)
              </label>
              <input
                type="text"
                placeholder="Enter your full name"
                value={panName}
                onChange={(e) => setPanName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
              />

              {/* Date of Birth Field */}
              <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
                Date of Birth
              </label>
              <input
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
              />

              {/* PAN Image Upload */}
              <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
                Upload PAN Image
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handlePanImageUpload}
                className="w-full border border-gray-300 rounded-md p-2"
              />
              {panImage && (
                <img
                  loading="lazy"
                  src={panImage}
                  alt="PAN Preview"
                  className="mt-2 h-24 rounded-md shadow-md"
                />
              )}
              <div className="flex justify-between mt-6">
                <button
                  onClick={() => handlePan()}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md"
                >
                  Save and continue
                </button>
              </div>
            </>
          )}

          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              id="non-gst"
              checked={isNonGst}
              onChange={() => {
                setIsNonGst(!isNonGst);
                setGstNumber("");
                setPanNumber("");
                setFullName("");
                setDob("");
                setPanImage(null);
              }}
              className="w-4 h-4"
            />
            <label
              htmlFor="non-gst"
              className="ml-2 text-gray-700 text-sm sm:text-base"
            >
              I only sell non-GST categories, like Books etc.
            </label>
          </div>
        </>
      )}

      {currentStep === 2 && (
        <>
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4">
            Shipping & Pickup Address
          </h2>
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
            Please enter your shipping and pickup addresses for order
            deliveries.
          </p>

          {/* Building No. */}
          <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">
            Building No.
          </label>
          <input
            type="text"
            placeholder="Enter building number"
            value={buildingNo}
            onChange={(e) => setBuildingNo(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Area */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Area
          </label>
          <input
            type="text"
            placeholder="Enter area name"
            value={area}
            onChange={(e) => setArea(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Pin Code */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Pin Code
          </label>
          <input
            type="text"
            placeholder="Enter pin code"
            maxLength={6}
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            State
          </label>
          <select
            value={state}
            onChange={(e) => {
              setState(e.target.value);
              setCity(""); // Reset city on state change
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select State</option>
            {Object.keys(statesWithCities).map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </select>

          {/* City Dropdown */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            City
          </label>
          <select
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            disabled={!state} // Disable if no state selected
          >
            <option value="">Select City</option>
            {state &&
              statesWithCities[state]?.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
          </select>

          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Pickup Address
          </label>
          <textarea
            placeholder="Enter your pickup address"
            value={pickupAddress}
            onChange={(e) => setPickupAddress(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 h-24"
          />
          <div className="flex justify-between mt-6">
            <button
              onClick={() => handleAddress()}
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Save and continue
            </button>
          </div>
        </>
      )}

      {currentStep === 3 && (
        <div className="sm:mt-0 mt-4 mx-auto bg-white  rounded-lg">
          {/* Bank Details Section */}
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-3 sm:mb-4">
            Bank Details
          </h2>
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
            Please enter your bank details for payment processing.
          </p>

          {/* Account Holder Name */}
          <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">
            Account Holder Name
          </label>
          <input
            type="text"
            placeholder="Enter account holder name"
            value={accountHolderName}
            onChange={(e) => setAccountHolderName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Bank Name */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Bank Name
          </label>
          <input
            type="text"
            placeholder="Enter bank name"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Account Number */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Account Number
          </label>
          <input
            type="text"
            placeholder="Enter account number"
            value={accountNumber}
            maxLength={16}
            minLength={16}
            onChange={(e) => setAccountNumber(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* IFSC Code */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            IFSC Code
          </label>
          <input
            type="text"
            placeholder="Enter IFSC code"
            value={ifscCode}
            onChange={(e) => setIfscCode(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Branch Name */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Branch Name
          </label>
          <input
            type="text"
            placeholder="Enter branch name"
            value={branchName}
            onChange={(e) => setBranchName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          />

          {/* Account Type (Dropdown) */}
          <label className="block text-gray-700 font-semibold mt-4 mb-2 text-sm sm:text-base">
            Account Type
          </label>
          <select
            value={accountType}
            onChange={(e) => setAccountType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Account Type</option>
            <option value="savings">Savings</option>
            <option value="current">Current</option>
          </select>
          <div className="flex justify-between mt-6">
            <button
              onClick={() => handleBank()}
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Save and continue
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GstRegistration;
